module.exports = __webpack_public_path__ + "img/screenshot3.56850a03.png";